import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./../styles/PortfolioDetails.css";
import { FaArrowLeft } from "react-icons/fa";

const PortfolioDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { item } = location.state || {};

    if (!item) {
        return (
            <div className="not-found">
                <h2>Project not found</h2>
                <button
                    onClick={() => navigate("/portfolio")}
                    className="back-button"
                >
                    &larr; Back to Portfolio
                </button>
            </div>
        );
    }

    const createMarkup = (htmlContent) => {
        return { __html: htmlContent };
    };

    return (
        <div className="portfolio-details">
            <div className="project-header">
                <div className="back-button-wrapper">
                    <button
                        onClick={() => navigate(-1)}
                        className="back-button"
                    >
                        <FaArrowLeft className="arrow-icon" />
                    </button>
                </div>
                <div className="project-details">
                    <h1>{item.title}</h1>
                </div>
            </div>
            <div className="project-content-grid">
                <div className="project-description-container">
                    <div className="project-image">
                        
                    </div>
                </div>
                <div className="project-text">
                    <h2>Project Overview</h2>
                    <p>{item.description}</p>
                    <img
                            src={item.image}
                            alt={item.title}
                            className="hero-images"
                        />
                    {item.details && (
                        <div className="project-detail">
                            <h2>Project Details</h2>
                            <div className="html-content"
                                dangerouslySetInnerHTML={createMarkup(
                                    item.details
                                )}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PortfolioDetails;
